$(document).ready(function () {
  $('.contact-form-submit').on('click', function (event) {
    event.preventDefault();
    let $form = $(this).closest('#contact-form');
    grecaptcha.ready(function () {
      grecaptcha
        .execute(envConfigs.reCAPTCHA_site_key, {
          action: 'submit',
        })
        .then(function (token) {
          $form.find('input[name=captcha]').val(token);
          $form
            .find('input[name=name]')
            .val($form.find('input[name=name]').val().trim());
          $form
            .find('input[name=email]')
            .val($form.find('input[name=email]').val().trim());
          $form.submit();
        });
    });
  });
});
